import React from 'react';
import { Link } from 'react-router';

const Breadcrumbs = ({ items, className }) => {
  return (
    <div className={`breadcrumbs text-sm ${className}`}>
      <ul className="w-fit">
        {items.map((item, index) => (
          <li key={index} className={`hover:text-primary ${index === items.length - 1 ? 'text-gray-900 font-bold' : ''}`}>
            {item.url ? (
              <Link to={item.url}>{item.text}</Link>
            ) : item.onClick ? (
              <a onClick={item.onClick} className="cursor-pointer">
                {item.text}
              </a>
            ) : (
              <span>{item.text}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Breadcrumbs;
